var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZone2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1147.411 2061",
    style: {
      enableBackground: "new 0 0 1147.411 2061"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "zone_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#00A3DE",
      strokeWidth: 46.6112,
      strokeMiterlimit: 10
    },
    d: "M7.717,1282.474H877.4 c71.511,0,129.482,57.972,129.482,129.484v246.107c0,71.511-57.971,129.483-129.482,129.483H769.863H2.279"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#00A3DE",
      strokeWidth: 46.6112,
      strokeMiterlimit: 10
    },
    d: "M577.617,636.518v359.088 c0,46.247,37.49,83.738,83.737,83.738h483.809"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#00A3DE",
      strokeWidth: 46.6112,
      strokeMiterlimit: 10
    },
    d: "M1145.163,636.541H178.566 c-50.099,0-90.711,40.613-90.711,90.712v558.079"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#00A3DE",
      strokeWidth: 46.6112,
      strokeMiterlimit: 10
    },
    x1: 1001.873,
    y1: 1618.225,
    x2: 1145.163,
    y2: 1618.225
  }), /*#__PURE__*/React.createElement("rect", {
    y: -0.594,
    style: {
      fill: "none"
    },
    width: 1147.411,
    height: 2061
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000080884936391018114050000005146046487727003310_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone2);
export default __webpack_public_path__ + "static/media/zone_2.628dd3f4.svg";
export { ForwardRef as ReactComponent };